import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { images } from '../../../Constants/ImageUrls';
import {
  clickedLoadMoreEvent,
  fireServedEvent,
} from '../../../Utils/CategoryPageUtils';
import { getDeviceType, removeDefaultParams } from '../../../Utils/helper';
import StickyCategoryCard from './StickyCategoryCard';
import {
  CategoryProductMain,
  CategoryTitleCTASection,
  ProductsGridNew,
} from './styled';

export default React.memo(function SubCategoryProducts(props) {
  const {
    item,
    category_name,
    setAddedToCart,
    tabsData,
    showPrice,
    tagStage,
    isCategoryPage,
    clicked,
    userType,
    outerIndex,
  } = props;
  const itemData = item?.items;
  const router = useRouter();
  const isBestSellerProduct = item?.itemName == 'BESTSELLERS';
  const isSingleCategory = tabsData.length == 1;
  const isMobile = getDeviceType() == 'mWeb';
  const isMultipleCategory = tabsData.length > 1;
  const bottomCategoryPageRef = useRef(null);
  const [showAnimation, setShowAnimation] = useState(false);

  const inititallyLoadHowMany = 4;
  const [showHowManyProducts, setShowHowManyProducts] = useState(
    isMultipleCategory ? 4 : 12,
  );
  const sectionShowCheck =
    item?.heading || (itemData?.length > showHowManyProducts && item?.webUrl);

  const bottomCategoryPageInteraction = useIntersection(bottomCategoryPageRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  });
  useEffect(() => {
    fireServedEvent(item, category_name);
  }, []);

  useEffect(() => {
    if (
      bottomCategoryPageInteraction?.isIntersecting &&
      tagStage === 3 &&
      itemData?.length > showHowManyProducts
    ) {
      viewMoreProductsHandler();
    }
  }, [bottomCategoryPageInteraction]);

  const viewMoreProductsHandler = () => {
    setShowHowManyProducts(item.items?.length);
    clickedLoadMoreEvent(item, category_name);
  };
  useEffect(() => {
    if (clicked) {
      setShowAnimation(true);
    }
  }, [router.asPath]);

  return (
    <>
      {itemData.length > 0 && (
        <>
          <CategoryProductMain
            className={showAnimation ? 'animateFromBottom' : ''}
            headingPresent={item?.heading}
          >
            {sectionShowCheck && (
              <CategoryTitleCTASection>
                {item?.heading ? <h2>{item?.heading}</h2> : null}
                {itemData?.length > showHowManyProducts && item?.webUrl ? (
                  <Link
                    href={{
                      pathname: item?.webUrl,
                      query: removeDefaultParams(router.query),
                    }}
                    passHref
                    locale={false}
                  >
                    <button>
                      View All {itemData?.length}
                      <img src={images.arrowdownforward} alt="" />
                    </button>
                  </Link>
                ) : null}
              </CategoryTitleCTASection>
            )}
            <ProductsGridNew>
              {itemData.map((element, index) => {
                // if (
                //     isSingleCategory ||
                //     (isMultipleCategory &&
                //         index < showHowManyProducts)
                // )
                // {
                return (
                  <StickyCategoryCard
                    key={item?.itemName + index}
                    data={element}
                    section={item}
                    category_name={category_name}
                    setAddedToCart={setAddedToCart}
                    showPrice={showPrice}
                    index={index}
                    userType={userType}
                    outerIndex={outerIndex}
                  />
                );
                // }
              })}
              <div ref={bottomCategoryPageRef}></div>
            </ProductsGridNew>
            {/* {isMultipleCategory &&
                        itemData?.length > showHowManyProducts &&
                        !isBestSellerProduct ? (
                            <ViewAllProducts
                                isCategoryPage={isCategoryPage}
                                sectionName={category_name}
                                tabsData={tabsData}
                                productsLength={itemData?.length}
                                category_name={item?.heading}
                                viewMoreProductsHandler={
                                    viewMoreProductsHandler
                                }
                                webUrl={item?.webUrl}
                            />
                        ) : null} */}
          </CategoryProductMain>
        </>
      )}
    </>
  );
});
